import { useStaticQuery, graphql } from 'gatsby'

export interface BarChartResources {
  group: {
    fieldValue: string
    totalCount: number
  }[]
}

const useBarChartData = () => {
  const { barChartResources }: { barChartResources: BarChartResources } =
    useStaticQuery(graphql`
      query barChartQuery {
        barChartResources: allAirtable(
          filter: { table: { eq: "Publishable explore page" } }
        ) {
          group(field: data___Topic) {
            fieldValue
            totalCount
          }
        }
      }
    `)

  return barChartResources
}

export default useBarChartData
